import { jsx as _jsx } from "react/jsx-runtime";
import { EditProgram } from '@src/components/Employee/EditProgram';
import { FullPageWrapper } from '@src/components/FullPageWrapper';
import { ProgramContextProvider } from '@src/contexts/ProgramContextProvider';
import { useAuth } from '@src/hooks/useAuth';
import { ProgramStatus } from '@src/types';
export const NewProgram = () => {
    const { currentUser } = useAuth();
    const NEW_PROGRAM = {
        id: 0,
        clientId: currentUser?.clientId || 0,
        employeeId: currentUser?.employeeId || 0,
        purpose: {
            selections: [],
            other: undefined,
            isActive: true, //default to true for backward compatibility
            isRequired: true, //default to true for backward compatibility
        },
        status: ProgramStatus.PENDING,
        documents: { docs: [] },
        fieldOfStudyName: '',
        programName: '',
        requestNum: '',
        otherSchool: '',
        otherFieldOfStudy: '',
        custom1: '',
        isSingleExpense: false,
    };
    return (_jsx(FullPageWrapper, { children: currentUser && (_jsx(ProgramContextProvider, { program: NEW_PROGRAM, children: _jsx(EditProgram, {}) })) }));
};
